export default __webpack_public_path__ + "static/media/empresa.21ad12d5.jpg";